import Cookies from 'js-cookie';
import type { CookieAttributes } from 'js-cookie';

import { API } from '../../api';

const prod = process.env.REACT_APP_ENV !== 'dev';
const params: CookieAttributes = {
  domain: prod ? '.nextlevel.ai' : '',
  path: '/',
  secure: prod || false,
  sameSite: prod ? 'lax' : 'lax',
};

export const store = {
  getAuth: () => {
    const token = Cookies.get('access_token');
    API.TOKEN = token;

    return token;
  },
  setAuth: (token: string) => {
    API.TOKEN = token;
    return Cookies.set('access_token', token, { ...params, expires: 30 });
  },
  clearAuth: () => {
    API.TOKEN = '';
    return Cookies.remove('access_token', params);
  },
};
